"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.error", {
		url: "/error/:code",
		controller: "ErrorController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/error/error.template.html"
	});
}]);
